export default __webpack_public_path__ + "static/MichałWołangiewicz-08cb1b4097a2e21050ed2b64a2435210.png";